"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var react_socks_1 = require("react-socks");

var Breakpoint_meta_1 = require("./Breakpoint.meta");

var Breakpoint =
/** @class */
function (_super) {
  __extends(Breakpoint, _super);

  function Breakpoint(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Breakpoint_meta_1.BREAKPOINT_CATEGORY_KEY;
    _this.componentKey = Breakpoint_meta_1.BREAKPOINT_COMPONENT_KEY;
    return _this;
  }

  Breakpoint.prototype.render = function () {
    var children = this.props.children;
    return react_1.default.createElement(react_socks_1.Breakpoint, __assign({}, this.props), children);
  };

  Breakpoint = __decorate([mobx_react_1.observer], Breakpoint);
  return Breakpoint;
}(shared_1.ComponentBase);

exports.Breakpoint = Breakpoint;
exports.default = shared_1.InjectedStyledComponent(Breakpoint, Breakpoint_meta_1.BREAKPOINT_CATEGORY_KEY, Breakpoint_meta_1.BREAKPOINT_COMPONENT_KEY);